import { useState, useEffect, useRef } from "react";
import { sampleEvent } from "../../../utils/landigPageData";
import { useParams } from "react-router-dom";
import {
    CheckCircle2, ChevronDown, ChevronRight, IndianRupee, ChevronLeft,
    Zap,
    Smartphone,
    Clock3,
    BusFront
} from "lucide-react";
import {
    BadgeCheck,
    ShieldCheck,
    Handshake,
    Headset,
} from "lucide-react";


import {
    Users,
    Users2,
    User,
    Heart,
    Baby,
    Accessibility,
} from "lucide-react";

import {
    MapPin,
    CalendarCheck2,
} from "lucide-react";


import {
    TimerReset,
    CalendarDays,
} from "lucide-react";
import {
    Sparkles,
    ArrowRight,
} from "lucide-react";
import { Reveal, Stars } from "./ui";

import { useNavigate } from "react-router-dom";
import { Car } from "lucide-react";
import "./TripDetailsStyle.css"
import {
    fetchTripDetails,
    getCarDetails,
    saveBookingJourney,
} from "../../../services/restapiService";
import { motion } from "framer-motion";
import NoDataFound from "./NoDataFound";
import ItineraryDetails from "./ItineraryDetails";
import AiRecommendation from "./AiRecommendation";

const TripDetailPage = () => {
    const { id } = useParams();
    const tourId = Number(id);
    const [progress, setProgress] = useState(0);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const navigate = useNavigate();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth();
    const [overview, setOverview] = useState(null);
    const [highlights, setHighlights] = useState([]);
    const [highlightContent, setHighlightContent] = useState(null);
    const [highlightBullets, setHighlightBullets] = useState([]);
    const [packages, setPackages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [open, setOpen] = useState(false);
    const [moreDetails, setMoreDetails] = useState({
        cancellation: [],
        details: [],
        inclusions: [],
        terms: [],
        howToUse: [],
    });
    const [tips, setTips] = useState([]);
    const [bringItems, setBringItems] = useState([]);
    const [durationTimings, setDurationTimings] = useState([]);
    const [pickupLocations, setPickupLocations] = useState([]);
    const [instructions, setInstructions] = useState([]);
    const [startingPrice, setStartingPrice] = useState(null);
    const [showCalendar, setShowCalendar] = useState(false);
    const [showGuests, setShowGuests] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null);
    const [baseMonth, setBaseMonth] = useState(today.getMonth());
    const [baseYear, setBaseYear] = useState(today.getFullYear());
    const [openParticipants, setOpenParticipants] = useState(false);
    const [openCarAddon, setOpenCarAddon] = useState(false);
    const [openTotalPriceCarDetails, setopenTotalPriceCarDetails] = useState(false);
    const [galleryImages, setGalleryImages] = useState([]);
    const [routeMap, setRouteMap] = useState(null);
    const [selectedPackage, setSelectedPackage] = useState(null);
    const [expandedPackage, setExpandedPackage] = useState(null);
    const [vehicleData, setVehicleData] = useState([]);
    const [showPriceDetails, setShowPriceDetails] = useState(false);
    const [showTimings, setShowTimings] = useState(false);
    const [selectedTiming, setSelectedTiming] = useState(null);
    const [timeError, setTimeError] = useState("");
    const [active, setActive] = useState(0);
    const [participants, setParticipants] = useState({
        adult: 0,
        child: 0,
        infant: 0,
    });
    const [explorePlaces, setExplorePlaces] = useState([]);
    const totalParticipants =
        participants.adult + participants.child + participants.infant;
    const price = selectedPackage?.offer_price
        ? parseFloat(selectedPackage.offer_price)
        : startingPrice || 0;
    const totalPrice =
        (participants.adult + participants.child) * price;
    const event = sampleEvent || {};
    const formatTime = (time) => {
        if (!time) return "";
        const [h, m] = time.split(":");
        const hour = ((+h + 11) % 12 + 1);
        const ampm = +h >= 12 ? "PM" : "AM";
        return `${hour}:${m} ${ampm}`;
    };
    const [selectedAddons, setSelectedAddons] = useState([]);
    // Select / Unselect Card
    const selectedPackageRef = useRef(null);
    const [exploreCategory, setExploreCategory] = useState("");
    const [topThings, setTopThings] = useState([]);
    const [noData, setNoData] = useState(false);
    const [quickFacts, setQuickFacts] = useState([]);
    const handleSelectAddon = (item) => {
        setSelectedAddons((prev) => {
            const exists = prev.some(
                (addon) => addon.id === item.id
            );

            let updated;

            if (exists) {
                // Unselect
                updated = prev.filter(
                    (addon) => addon.id !== item.id
                );
            } else {
                // Add to existing selection
                updated = [...prev, item];
            }

            setopenTotalPriceCarDetails(updated.length > 0);

            return updated;
        });
    };
    const [highlightItems, setHighlightItems] = useState([]);
    const [overviewSections, setOverviewSections] = useState([]);
    const [policies, setPolicies] = useState([]);
    const [dayPlan, setDayPlan] = useState([]);
    const [frequentlyBookedTogether, setFrequentlyBookedTogether] = useState([]);
    const [exploreMoreDestinations, setExploreMoreDestinations] = useState([]);
    // Total Count
    const totalSelected = selectedAddons.length;
    // Total Price
    const totalPriceAddons = selectedAddons.reduce((sum, item) => {
        return sum + Number(item.price);
    }, 0);
    const [reviews, setReviews] = useState([]);
    const [faqs, setFaqs] = useState([]);
    const exploreScrollRef = useRef(null);
    const isTripDataEmpty = (data) => {
        if (!data) return true;

        return (
            !data.overview &&
            data.packages?.length === 0 &&
            data.gallery?.length === 0 &&
            !data.routeMap &&
            data.highlights?.length === 0 &&
            data.tips?.length === 0 &&
            data.bring?.length === 0 &&
            data.duration?.length === 0 &&
            data.pickup?.length === 0 &&
            data.instructions?.length === 0
        );
    };

    useEffect(() => {
        if (!tourId) return;
        const loadTripDetails = async () => {
            try {
                const token = localStorage.getItem("token");
                const res = await fetchTripDetails(token, tourId);
                const data = res?.data?.data;

                if (isTripDataEmpty(data)) {
                    setNoData(true);
                    return;
                }
                console.log("data ======", data);

                // ---------------- OVERVIEW ----------------
                setOverview(data.overview || null);
                // ---------------- HIGHLIGHTS ----------------
                if (data.highlights && data.highlights.length > 0) {
                    setHighlightContent(data.highlights[0]);
                }
                // ---------------- PACKAGES ----------------
                const pkgData = data.packages || [];
                setPackages(pkgData);
                const prices = pkgData
                    .map(p => parseFloat(p.offer_price))
                    .filter(p => !isNaN(p));
                const lowest = prices.length ? Math.min(...prices) : null;
                setStartingPrice(lowest);
                const defaultPkg = pkgData.find(
                    p => parseFloat(p.offer_price) === lowest
                );
                setSelectedPackage(defaultPkg);
                // setStartingPrice(prices.length ? Math.min(...prices) : null);
                // ---------------- TIPS ----------------
                setTips(data.tips || []);
                // ---------------- WHAT TO BRING ----------------
                setBringItems(data.bring || []);
                // ---------------- DURATION ----------------
                setDurationTimings(data.duration || []);
                // ---------------- PICKUP ----------------
                setPickupLocations(data.pickup || []);
                // ---------------- INSTRUCTIONS ----------------
                setInstructions(data.instructions || []);
                //  ---------------- GALLERY ----------------
                setGalleryImages(data.gallery || []);
                // ---------------- ROUTE MAP ----------------
                setRouteMap(data.routeMap || null);
                // ---------------- EXPLORE PLACES ---------------
                setExplorePlaces(data.explorePlaces || []);

                // ---------------- QUICK FACTS ----------------
                setQuickFacts(data.quickFacts || []);


                // ---------------- TOP THINGS ----------------
                setTopThings(data.topThings || []);
                // ---------------- OVERVIEW SECTIONS ----------------
                setOverviewSections(data.overviewSections || []);
                // ---------------- REVIEWS ----------------
                setReviews(data.reviews || []);
                // ---------------- FAQs ----------------
                setFaqs(data.faqs || []);
                // ---------------- policies ----------------

                setPolicies(data.policies || []);

                // ---------------- HIGHLIGHT ITEMS ----------------
                setHighlightItems(data.highlightItems || []);

                // ---------------- DAY PLAN ----------------
                setDayPlan(data.dayPlan || []);
                setFrequentlyBookedTogether(data.frequentlyBookedTogether || []);
                setExploreMoreDestinations(data.exploreMoreDestinations || []);


                const category =
                    data.topThings?.[0]?.category ||
                    data.overview?.destination ||
                    "";

                setExploreCategory(category);

            } catch (err) {
                console.error("loadTripDetails ERROR:", err);
            } finally {
                setLoading(false);
            }
        };
        loadTripDetails();
    }, [tourId]);

    const thumbs =
        galleryImages?.map(
            (img) => `https://api.gosehari.com${img.image_path}`
        ) || [];


    const updateCount = (type, action) => {
        setParticipants(prev => {
            const newValue =
                action === "inc"
                    ? prev[type] + 1
                    : Math.max(0, prev[type] - 1); // prevent negative
            return { ...prev, [type]: newValue };
        });
    };


    const generateCalendar = (year, month) => {
        const firstDay = new Date(year, month, 1).getDay();
        const daysInMonth = new Date(year, month + 1, 0).getDate();
        const days = [];
        for (let i = 0; i < firstDay; i++) days.push(null);
        for (let d = 1; d <= daysInMonth; d++) days.push(d);
        return days;
    };
    const TABS = ["Overview", "Highlights", "What to Bring", "Instructions", "Reviews", "FAQ's", "Policies"];
    const [activeTab, setActiveTab] = useState("Overview");
    const scrollRef = useRef(null);
    const contentRef = useRef(null);
    const svgRef = useRef(null);
    const pathRef = useRef(null);
    const pinRef = useRef(null);
    const [activeIndex, setActiveIndex] = useState(0);
    const itemRefs = useRef([]);

    const handleScroll = () => {
        const container = scrollRef.current;
        if (!container) return;
        const containerTop = container.getBoundingClientRect().top;
        let currentIndex = 0;
        itemRefs.current.forEach((el, index) => {
            if (!el) return;
            const rect = el.getBoundingClientRect();
            // item crosses middle of scroll container
            if (rect.top - containerTop < container.clientHeight / 2) {
                currentIndex = index;
            }
        });
        setActiveIndex(currentIndex);
        // move pin to active item
        const activeEl = itemRefs.current[currentIndex];
        if (activeEl && pinRef.current) {
            const elTop =
                activeEl.offsetTop +
                activeEl.offsetHeight / 2;
            pinRef.current.style.transform = `translateY(${elTop}px)`;
        }
    };
useEffect(() => {
    const container = exploreScrollRef.current;

    if (!container || explorePlaces.length <= 1) return;

    let animationFrame;
    let isPaused = false;
    let lastTime = performance.now();

    const scroll = (currentTime) => {
        const deltaTime = currentTime - lastTime;
        lastTime = currentTime;

        if (!isPaused) {
            // Very slow smooth scrolling
            container.scrollLeft += deltaTime * 0.025;

            // Restart from beginning
            if (
                container.scrollLeft + container.clientWidth >=
                container.scrollWidth - 1
            ) {
                container.scrollLeft = 0;
            }
        }

        animationFrame = requestAnimationFrame(scroll);
    };

    const pause = () => {
        isPaused = true;
    };

    const resume = () => {
        isPaused = false;
        lastTime = performance.now();
    };

    container.addEventListener("mouseenter", pause);
    container.addEventListener("mouseleave", resume);

    animationFrame = requestAnimationFrame(scroll);

    return () => {
        cancelAnimationFrame(animationFrame);

        container.removeEventListener("mouseenter", pause);
        container.removeEventListener("mouseleave", resume);
    };
}, [explorePlaces]);


    useEffect(() => {
        const pin = pinRef.current;
        const item = itemRefs.current[activeIndex];
        const container = scrollRef.current;
        if (!pin || !item || !container) return;
        const itemRect = item.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();
        const y =
            itemRect.top -
            containerRect.top +
            item.offsetHeight / 2;
        pin.style.transform = `translateY(${y}px)`;
    }, [activeIndex]);
    const InfoRow = ({ icon: Icon, text }) => (
        <div className="flex items-center gap-2 text-gray-600">
            <Icon size={16} className="text-blue-600 shrink-0" />
            <h4>{text}</h4>
        </div>
    );

    const vehicleDetails = async () => {
        try {
            const res = await getCarDetails(tourId);

            if (res.data.success) {
                setVehicleData(res.data.data || []);

                console.log("res.data.data==", res.data.data);

            }
        } catch (error) {
            console.error("Error fetching vehicle details:", error);
        }
    };

    useEffect(() => {
        if (tourId) {
            vehicleDetails();
        }
    }, [tourId]);


    const vehicleStrategies = vehicleData.map((item) => {
        const paxMatch = item.pax_capacity.match(/(\d+)-(\d+)/);

        return {
            id: item.id,
            min: paxMatch ? Number(paxMatch[1]) : 1,
            max: paxMatch ? Number(paxMatch[2]) : 99,
            title: item.title,
            type: `${item.vehicle_type} (${item.pax_capacity})`,
            price: parseFloat(item.price),
            image: `https://api.gosehari.com/uploads/cars/${item.image}`
        };
    });


    const totalGuests =
        participants.adult +
        participants.child +
        participants.infant;


    const parsePrice = (price) => Number(price);

    // PACKAGE TOTAL
    const packageTotal =
        totalGuests * Number(selectedPackage?.offer_price || 0);
    const matchingVehicles = vehicleStrategies
        .filter(
            item =>
                totalGuests >= item.min &&
                totalGuests <= item.max
        )
        .sort((a, b) => parsePrice(a.price) - parsePrice(b.price));
    const availableVehicles =
        totalGuests === 1
            ? [matchingVehicles[0]]
            : matchingVehicles;
    console.log("availableVehicles", availableVehicles);

    const cheapestVehicle = availableVehicles[0];

    useEffect(() => {
        if (totalGuests === 1 && cheapestVehicle) {
            setSelectedAddons([cheapestVehicle]);
            setopenTotalPriceCarDetails(true);
        } else {
            setSelectedAddons([]);
            setopenTotalPriceCarDetails(false);
        }
    }, [totalGuests]);

    console.log("cheapestVehicle", cheapestVehicle);


    const getVehicleText = (count) => {
        if (count > 20) {
            return "Maximum guest limit of 20 reached.";
        }

        const strategy = vehicleStrategies.find(
            (item) => count >= item.min && count <= item.max
        );

        return strategy?.type || "";
    };





    const recommendedVehicle =
        vehicleStrategies
            .filter(
                (item) =>
                    totalGuests >= item.min &&
                    totalGuests <= item.max
            )
            .sort(
                (a, b) =>
                    parsePrice(a.price) - parsePrice(b.price)
            )[0];



    const grandTotal = packageTotal;




    const handleContinue = async () => {


        // Validate time selection
        if (!selectedTiming) {
            setTimeError("Please select a time slot.");
            return;
        }
        setTimeError("");

        try {



            const response = await saveBookingJourney({
                tour_id: tourId,
                tour_title: overview?.title,
                location: overview?.location,
                tour_image: galleryImages?.[0]
                    ? `https://api.gosehari.com${galleryImages[0].image_path}`
                    : null,

                selected_date: selectedDate,
                selected_time: selectedTiming?.timings,
                adults: participants?.adult || 0,
                children: participants?.child || 0,
                infants: participants?.infant || 0,

                total_guests: totalParticipants,

                package_id: selectedPackage?.id,
                package_name: selectedPackage?.package_name,


                activity_price_per_person: selectedPackage?.offer_price,
                activity_price: totalPrice,

                page_name: "trip_details",
                booking_status: "booking_summary",

                selectedVehicles: selectedAddons
            });


            const journeyId = response?.data?.journeyId;

            localStorage.setItem("journeyId", journeyId);

            navigate("/booking-summary", {
                state: {
                    journeyId
                }
            });

        } catch (error) {
            console.error("Failed to save booking journey", error);
        }
    };





    if (loading) {
        return (
            <div className="flex min-h-screen items-center justify-center">
                <p className="text-lg font-medium text-gray-600">
                    Loading tour details...
                </p>
            </div>
        );
    }

    if (noData) {
        return (
            <NoDataFound
                title="Tour Details Coming Soon"
                description="We're currently updating the details for this experience. Please check back shortly, or contact us for more information."
                phone="+91 9876543210"
                email="support@gosehari.com"
            />
        );
    }


    return (
        <div className="container trip-details-page pb-24 lg:pb-0">

            <div className="min-h-screen text-gray-700">
                <div className="mt-4 mt-lg-5">

                    <div className="mb-1">
                        <div className="flex flex-wrap items-center gap-2 text-[15px] text-slate-500">
                            <a
                                href="/"
                                className="hover:text-blue-600 transition"
                            >
                                Home
                            </a>

                            <ChevronRight size={15} />

                            <a
                                href="/thailand"
                                className="text-sky-600 font-bold hover:text-blue-600 transition"
                            >
                                Thailand
                            </a>

                            <ChevronRight size={15} />

                            <a
                                href="/pattaya"
                                className="text-sky-600 font-bold hover:text-blue-600 transition"
                            >
                                {exploreCategory}
                            </a>

                            <ChevronRight size={15} />

                            <a
                                href="/attractions"
                                className="text-sky-600 font-bold hover:text-blue-600 transition"
                            >
                                Attractions
                            </a>

                            <ChevronRight size={15} />

                            <span className="font-semibold text-slate-900">
                                {overview?.title}
                            </span>

                        </div>

                        {/* Explore */}

                        <div className="mt-4 rounded-2xl bg-sky-50 p-4">
                            <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
                                <div className="flex items-center gap-3 shrink-0">
                                    <div className="flex h-10 w-10 items-center justify-center rounded-full bg-yellow-100">
                                        <Sparkles
                                            size={18}
                                            className="text-yellow-500" />
                                    </div>
                                    <div>
                                        <p className="text-[15px] font-bold text-slate-800">
                                            {explorePlaces?.[0]?.main_title || "Explore"}
                                        </p>
                                        <p className="text-xs text-slate-500">
                                            {explorePlaces?.[0]?.sub_title || "Top attractions nearby"}
                                        </p>
                                    </div>
                                </div>
                                {/* Cards */}
                                <div
                                    ref={exploreScrollRef}
                                    className="flex flex-1 gap-3 overflow-x-auto scrollbar-hide pb-1"
                                >
                                    {explorePlaces.map((item) => (
                                        <button
                                            key={item.id}
                                            className="group relative h-16 min-w-[150px] flex-none overflow-hidden rounded-xl border border-white/30 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
                                        >
                                            {/* Background Image */}
                                            {item.image_url ? (
                                                <img
                                                    src={item.image_url.startsWith("http") ? item.image_url : `https://api.gosehari.com${item.image_url}`}
                                                    alt={item.name}
                                                    className="absolute inset-0 h-full w-full max-w-none object-cover transition-transform duration-500 group-hover:scale-110"
                                                />
                                            ) : (
                                                <div className="absolute inset-0 flex items-center justify-center bg-slate-300 text-xs text-slate-600">No image</div>
                                            )}
                                      
                                        </button>
                                    ))}
                                </div>
                                {/* Right */}
                                <button className="group flex items-center gap-2 whitespace-nowrap text-sm font-semibold text-blue-600 hover:text-blue-700">
                                    View All Attractions
                                    <ArrowRight
                                        size={16}
                                        className="transition group-hover:translate-x-1"
                                    />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>



                {/* ================= MAIN CONTENT ================= */}
                <div className="container grid grid-cols-1 gap-3 pt-10 lg:grid-cols-10 lg:gap-10">
                    <div className="min-w-0 space-y-10 lg:col-span-7">
                        {/* ================= TOUR OVERVIEW BLOCK ================= */}
                        <Reveal>
                            <div className="trip-gallery relative h-[280px] overflow-hidden rounded-2xl border border-line bg-black shadow-card sm:h-[360px] md:h-[440px] lg:h-[500px]">

                                {/* Main Image */}
                                <motion.img
                                    key={active}
                                    src={thumbs[active] || ""}
                                    alt="Gallery"
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    transition={{ duration: 0.35 }}
                                    className="trip-gallery-image h-full w-full object-cover"
                                />

                                {/* Dark Gradient */}
                                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-black/10" />

                  

                                {/* Previous */}
                                <button
                                    type="button"
                                    disabled={thumbs.length <= 1}
                                    onClick={() =>
                                        setActive((a) => (a - 1 + thumbs.length) % thumbs.length)
                                    }
                                    aria-label="Previous gallery image"
                                    className="trip-gallery-control absolute left-2 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-white/90 shadow-lg transition hover:bg-white disabled:cursor-not-allowed disabled:opacity-50 sm:left-4 sm:h-11 sm:w-11"
                                >
                                    <ChevronLeft className="h-5 w-5 sm:h-[22px] sm:w-[22px]" />
                                </button>

                                {/* Next */}
                                <button
                                    type="button"
                                    disabled={thumbs.length <= 1}
                                    onClick={() =>
                                        setActive((a) => (a + 1) % thumbs.length)
                                    }
                                    aria-label="Next gallery image"
                                    className="trip-gallery-control absolute right-2 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-white/90 shadow-lg transition hover:bg-white disabled:cursor-not-allowed disabled:opacity-50 sm:right-4 sm:h-11 sm:w-11"
                                >
                                    <ChevronRight className="h-5 w-5 sm:h-[22px] sm:w-[22px]" />
                                </button>


                                {/* Feature Icons - Top Right */}
                                <div className="trip-gallery-features absolute left-3 right-3 top-3 z-20 xl:left-auto xl:right-5 xl:top-5">
                                    <div className="flex flex-wrap justify-end gap-2 sm:gap-3">
                                        <div className="flex items-center gap-2 rounded-full bg-white/25 px-2.5 py-2 shadow-xl backdrop-blur-xl transition-all duration-300 hover:bg-white sm:px-4 sm:py-2.5">
                                            <Clock3 size={18} className="text-white drop-shadow" />
                                            <span className="whitespace-nowrap text-xs font-semibold text-white sm:text-sm">
                                                2–3 Hours
                                            </span>
                                        </div>

                                        <div className="flex items-center gap-2 rounded-full bg-white/25 px-2.5 py-2 shadow-xl backdrop-blur-xl transition-all duration-300 hover:bg-white sm:px-4 sm:py-2.5">
                                            <BusFront size={18} className="text-white drop-shadow" />
                                            <span className="whitespace-nowrap text-xs font-semibold text-white sm:text-sm">
                                                Hotel Pickup
                                            </span>
                                        </div>

                                        <div className="flex items-center gap-2 rounded-full bg-white/25 px-2.5 py-2 shadow-xl backdrop-blur-xl transition-all duration-300 hover:bg-white sm:px-4 sm:py-2.5">
                                            <Smartphone size={18} className="text-white drop-shadow" />
                                            <span className="whitespace-nowrap text-xs font-semibold text-white sm:text-sm">
                                                Mobile Voucher
                                            </span>
                                        </div>

                                        <div className="flex items-center gap-2 rounded-full bg-white/25 px-2.5 py-2 shadow-xl backdrop-blur-xl transition-all duration-300 hover:bg-white hover:text-black sm:px-4 sm:py-2.5">
                                            <Zap size={18} className="text-yellow-600" />
                                            <span className="whitespace-nowrap text-xs font-semibold text-white sm:text-sm">
                                                Instant Confirmation
                                            </span>
                                        </div>

                                    </div>
                                </div>

                                {/* Bottom Content */}
                                <div className="absolute bottom-0 left-0 right-0 p-2 sm:p-4">
                                    {/* Bottom Thumbnails */}
                                    <div className="flex max-w-full justify-center">
                                        <div className="trip-gallery-thumbnails flex max-w-full gap-2 overflow-x-auto scrollbar-hide rounded-xl bg-black/20 px-2 py-2 backdrop-blur-sm sm:px-3">
                                            {thumbs.map((img, i) => (
                                                <button
                                                    key={i}
                                                    type="button"
                                                    onClick={() => setActive(i)}
                                                    aria-label={`Show gallery image ${i + 1}`}
                                                    className={`h-12 w-20 flex-shrink-0 overflow-hidden rounded-lg border-2 transition-all duration-300 sm:h-16 sm:w-24 ${active === i
                                                        ? "border-white shadow-lg scale-105"
                                                        : "border-white/30 hover:border-white hover:scale-105"
                                                        }`}
                                                >
                                                    <img
                                                        src={img}
                                                        alt=""
                                                        className="h-full w-full object-cover"
                                                    />
                                                </button>
                                            ))}
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </Reveal>



                        <div className="">
                            <h2 className="font-bold text-gray-900 leading-snug">
                                {overview?.title}
                            </h2>
                            <p className="mt-2 text-base text-gray-600 flex items-center gap-2">
                                📍 <span className="uppercase">{overview?.location}</span>
                            </p>

                            <div className="my-6 border-t"></div>

                            <p className="text-gray-600 mb-3"> {overview?.read_more_text}</p>

                            <p className="text-gray-600 mb-3">
                                {overview?.subtitle}
                            </p>
                        </div>



                        <div className="mt-8 grid grid-cols-2 lg:grid-cols-4 gap-6">

                            {/* Best Price */}
                            <div className="flex items-center gap-3 group">
                                <div className="flex h-12 w-12 items-center justify-center rounded-full border border-blue-200 bg-blue-50 text-blue-600 transition-all duration-300 group-hover:bg-blue-600 group-hover:text-white">
                                    <BadgeCheck size={24} />
                                </div>

                                <div>
                                    <h4 className="text-base font-semibold text-slate-900 leading-5">
                                        Best Price
                                    </h4>
                                    <p className="text-sm text-slate-500">
                                        Guarantee
                                    </p>
                                </div>
                            </div>

                            {/* No Hidden Charges */}
                            <div className="flex items-center gap-3 group">
                                <div className="flex h-12 w-12 items-center justify-center rounded-full border border-blue-200 bg-blue-50 text-blue-600 transition-all duration-300 group-hover:bg-blue-600 group-hover:text-white">
                                    <ShieldCheck size={24} />
                                </div>

                                <div>
                                    <h4 className="text-base font-semibold text-slate-900 leading-5">
                                        No Hidden
                                    </h4>
                                    <p className="text-sm text-slate-500">
                                        Charges
                                    </p>
                                </div>
                            </div>

                            {/* Trusted Partner */}
                            <div className="flex items-center gap-3 group">
                                <div className="flex h-12 w-12 items-center justify-center rounded-full border border-blue-200 bg-blue-50 text-blue-600 transition-all duration-300 group-hover:bg-blue-600 group-hover:text-white">
                                    <Handshake size={24} />
                                </div>

                                <div>
                                    <h4 className="text-base font-semibold text-slate-900 leading-5">
                                        Trusted
                                    </h4>
                                    <p className="text-sm text-slate-500">
                                        Local Partner
                                    </p>
                                </div>
                            </div>

                            {/* Customer Support */}
                            <div className="flex items-center gap-3 group">
                                <div className="flex h-12 w-12 items-center justify-center rounded-full border border-blue-200 bg-blue-50 text-blue-600 transition-all duration-300 group-hover:bg-blue-600 group-hover:text-white">
                                    <Headset size={24} />
                                </div>

                                <div>
                                    <h4 className="text-base font-semibold text-slate-900 leading-5">
                                        24/7
                                    </h4>
                                    <p className="text-sm text-slate-500">
                                        Customer Support
                                    </p>
                                </div>
                            </div>

                        </div>
                        {/* ================= Quick Facts ================= */}

                        <div>
                            <h2 className="font-bold text-slate-900 mb-3">
                                Quick Facts
                            </h2>

                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                                {quickFacts.map((fact) => (
                                    <div
                                        key={fact.id}
                                        className="group rounded-2xl border border-slate-200 bg-white p-2 transition-all duration-300 hover:border-blue-500 hover:shadow-lg"
                                    >
                                        <div className="space-y-4">
                                            <div className="flex items-center gap-3">

                                                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-blue-50 text-blue-600">
                                                    {fact.fact_type === "duration" && (
                                                        <TimerReset size={20} />
                                                    )}

                                                    {fact.fact_type === "start_time" && (
                                                        <Clock3 size={20} />
                                                    )}

                                                    {fact.fact_type === "tour_type" && (
                                                        <MapPin size={20} />
                                                    )}

                                                    {fact.fact_type === "group_size" && (
                                                        <Users size={20} />
                                                    )}

                                                    {fact.fact_type === "transportation" && (
                                                        <Car size={20} />
                                                    )}

                                                    {fact.fact_type === "destinations" && (
                                                        <MapPin size={20} />
                                                    )}
                                                </div>

                                                <div>
                                                    <p className="text-xs text-slate-500">
                                                        {fact.fact_label}
                                                    </p>

                                                    <h4 className="text-sm font-bold text-slate-900">
                                                        {fact.fact_value}
                                                    </h4>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                ))}

                            </div>
                        </div>


                        <div className="" id="price-section">
                            <h2 className="font-bold text-slate-900 mb-3">
                                Select Packages
                            </h2>

                            <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6">
                                {packages.map((pkg, index) => (
                                    <div
                                        key={pkg.id || index}
                                        className={`transition-all duration-300 ${selectedPackage?.id === pkg.id
                                            ? "scale-[1.02]"
                                            : "hover:-translate-y-1 hover:shadow-xl"
                                            }`}
                                    >
                                        <div
                                            className={`h-full cursor-pointer rounded-2xl border p-3 transition-all duration-300 ${selectedPackage?.id === pkg.id
                                                ? "border-blue-400 bg-gradient-to-br from-sky-50 via-white to-blue-100 shadow-xl "
                                                : "border-gray-200 bg-white hover:border-blue-300 hover:shadow-lg"
                                                }`}
                                            onClick={() => {
                                                setSelectedPackage(pkg);
                                                setTimeout(() => {
                                                    const card = document.getElementById(
                                                        "selected-package-card"
                                                    );

                                                    if (card) {
                                                        const y =
                                                            card.getBoundingClientRect().top +
                                                            window.pageYOffset -
                                                            100;

                                                    }
                                                }, 100);
                                            }}
                                        >
                                            {/* Header */}
                                            <div className="flex justify-between items-start">
                                                <h3 className="font-bold leading-tight">
                                                    {pkg.package_name}
                                                </h3>

                                                <span className="flex items-center gap-1 text-sm text-gray-600">
                                                    <Clock3 size={15} />
                                                    {pkg.duration_hours}h
                                                </span>
                                            </div>

                                            {/* Price */}
                                            <div className="mt-4">
                                                {pkg.original_price && (
                                                    <p className="text-gray-400 line-through text-lg">
                                                        ₹{pkg.original_price}
                                                    </p>
                                                )}

                                                <div className="flex items-end gap-2">
                                                    <span className="text-3xl font-bold text-black">
                                                        ₹{pkg.offer_price}
                                                    </span>

                                                    <span className="pb-1 text-gray-500">
                                                        / Person
                                                    </span>
                                                </div>
                                            </div>

                                            {/* Button */}
                                            <button
                                                className={`mt-2 w-full rounded-xl py-3 font-semibold transition ${selectedPackage?.id === pkg.id
                                                    ? "text-emerald"
                                                    : "text-black hover:text-blue"
                                                    }`}
                                            >
                                                {selectedPackage?.id === pkg.id
                                                    ? "✓ Selected Package"
                                                    : "Select Package"}
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>








                        <div className="space-y-8">
                            <div className="flex overflow-x-auto">
                                {TABS?.map((tab) => (
                                    <button
                                        key={tab}
                                        onClick={() => setActiveTab(tab)}
                                        className={`px-6 py-3 font-bold border-b-2 transition-all 
                                      ${activeTab === tab
                                                ? "border-blue-600 text-blue-600"
                                                : "border-transparent text-gray-500 hover:text-gray-700"
                                            }`} >
                                        {tab}
                                    </button>
                                ))}
                            </div>
                        </div>
                        <div className="space-y-8 mb-4">
                            {activeTab === "Overview" && (
                                <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 mt-8">

                                    {/* ================= Why You'll Love This Experience ================= */}

                                    <div className="rounded-3xl border border-orange-100 bg-gradient-to-br from-orange-50 via-white to-red-50 p-6 shadow-sm hover:shadow-lg transition-all duration-300">

                                        <div className="flex items-center gap-2 mb-5">
                                            <h3 className="font-bold text-red-600">
                                                {overviewSections.find(
                                                    item => item.section_type === "bullet"
                                                )?.section_title || "Why You'll Love This Experience"}
                                            </h3>

                                            <span className="text-2xl">❤️</span>
                                        </div>

                                        <div className="space-y-4">

                                            {overviewSections
                                                .filter(item => item.section_type === "bullet")
                                                .sort((a, b) => a.display_order - b.display_order)
                                                .map((item) => (
                                                    <div
                                                        key={item.id}
                                                        className="flex items-start gap-3"
                                                    >
                                                        <div className="mt-1">
                                                            <CheckCircle2
                                                                className="text-green-500"
                                                                size={22}
                                                            />
                                                        </div>

                                                        <p className="text-gray-700">
                                                            {item.content}
                                                        </p>
                                                    </div>
                                                ))}

                                        </div>
                                    </div>


                                    {/* ================= Perfect For ================= */}

                                    <div className="rounded-3xl border border-emerald-100 bg-gradient-to-br from-emerald-50 via-white to-cyan-50 p-6 shadow-sm hover:shadow-lg transition-all duration-300">

                                        <h3 className="font-bold text-slate-900 mb-6">
                                            {overviewSections.find(
                                                item => item.section_type === "perfect_for"
                                            )?.section_title || "Perfect For"}
                                        </h3>

                                        <div className="flex flex-wrap gap-3">

                                            {overviewSections
                                                .filter(item => item.section_type === "perfect_for")
                                                .sort((a, b) => a.display_order - b.display_order)
                                                .map((item, index) => (
                                                    <div
                                                        key={item.id}
                                                        className="flex items-center gap-2 rounded-full border border-gray-200 bg-white px-5 py-3 hover:border-blue-500 hover:shadow transition"
                                                    >
                                                        <Users
                                                            size={18}
                                                            className="text-blue-600"
                                                        />

                                                        <span>
                                                            {item.content}
                                                        </span>
                                                    </div>
                                                ))}

                                        </div>
                                    </div>

                                </div>
                            )}




                            {/* Highlights */}
                            {activeTab === "Highlights" && (
                                <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 mt-8">

                                    {highlightItems.map((item) => (
                                        <div
                                            key={item.id}
                                            className="rounded-3xl border border-orange-100 bg-gradient-to-br from-orange-50 via-white to-red-50 p-6 shadow-sm hover:shadow-lg transition-all duration-300"
                                        >
                                            <div className="flex items-start gap-3 mb-3">
                                                <div className="mt-1">
                                                    <CheckCircle2
                                                        className="text-green-500"
                                                        size={22}
                                                    />
                                                </div>

                                                <div>
                                                    <h3 className="font-bold text-red-600">
                                                        {item.title}
                                                    </h3>

                                                    <p className="text-gray-700 mt-2">
                                                        {item.description}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}

                                </div>
                            )}


                            {/* What to Bring */}
                            {activeTab === "What to Bring" && (
                                <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 mt-8">

                                    {/* ================= Why You'll Love This Experience ================= */}

                                    <div className="rounded-3xl border border-orange-100 bg-gradient-to-br from-orange-50 via-white to-red-50 p-6 shadow-sm hover:shadow-lg transition-all duration-300">
                                        <div className="flex items-center gap-2 mb-2">
                                            <h3 className="font-bold text-red-600">
                                                What to Bring
                                            </h3>

                                            {/* <span className="text-2xl">❤️</span> */}

                                        </div>

                                        <div className="space-y-4">
                                            <div className="flex flex-wrap gap-3">
                                                {bringItems.map((item) => (
                                                    <div
                                                        key={item.id}
                                                        className="flex items-center gap-2 rounded-full border border-gray-200 bg-white px-3 py-1 hover:border-blue-500 hover:shadow transition"
                                                    >
                                                        <span className="text-lg">
                                                            {item.icon}
                                                        </span>

                                                        <span className="text-gray-700 text-sm font-medium">
                                                            {item.item}
                                                        </span>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>

                                    </div>

                                    {/* ================= Perfect For ================= */}

                                    <div className="rounded-3xl border border-emerald-100 bg-gradient-to-br from-emerald-50 via-white to-cyan-50 p-6 shadow-sm hover:shadow-lg transition-all duration-300">

                                        <h3 className="font-bold text-slate-900 mb-6">
                                            Perfect For
                                        </h3>

                                        <div className="flex flex-wrap gap-3">

                                            <div className="flex items-center gap-2 rounded-full border border-gray-200 bg-white px-5 py-3 hover:border-blue-500 hover:shadow transition">
                                                <Users size={18} className="text-blue-600" />
                                                <span>Families</span>
                                            </div>

                                            <div className="flex items-center gap-2 rounded-full border border-gray-200 bg-white px-5 py-3 hover:border-pink-500 hover:shadow transition">
                                                <Heart size={18} className="text-pink-500" />
                                                <span>Couples</span>
                                            </div>

                                            <div className="flex items-center gap-2 rounded-full border border-gray-200 bg-white px-5 py-3 hover:border-indigo-500 hover:shadow transition">
                                                <Users2 size={18} className="text-indigo-600" />
                                                <span>Friends</span>
                                            </div>

                                            <div className="flex items-center gap-2 rounded-full border border-gray-200 bg-white px-5 py-3 hover:border-orange-500 hover:shadow transition">
                                                <User size={18} className="text-orange-500" />
                                                <span>Solo Travelers</span>
                                            </div>

                                            <div className="flex items-center gap-2 rounded-full border border-gray-200 bg-white px-5 py-3 hover:border-green-500 hover:shadow transition">
                                                <Baby size={18} className="text-green-600" />
                                                <span>Kids</span>
                                            </div>

                                            <div className="flex items-center gap-2 rounded-full border border-gray-200 bg-white px-5 py-3 hover:border-purple-500 hover:shadow transition">
                                                <Accessibility size={18} className="text-purple-600" />
                                                <span>Senior Citizens</span>
                                            </div>

                                        </div>

                                    </div>

                                </div>
                            )}


                            {/* Instructions*/}
                            {activeTab === "Instructions" && (
                                <div className="bg-white p-6 rounded-xl shadow-md border mt-8">

                                    <div className="rounded-3xl border border-orange-100 bg-gradient-to-br from-orange-50 via-white to-red-50 p-6 shadow-sm hover:shadow-lg transition-all duration-300">

                                        <div className="flex items-center gap-2 mb-2">
                                            <h3 className="font-bold text-red-600">
                                                Before You Go
                                            </h3>
                                        </div>

                                        <div className="space-y-3">
                                            {instructions.map((ins) => (
                                                <div
                                                    key={ins.id}
                                                    className="flex items-start gap-3"
                                                >
                                                    <span className="text-red-500 font-bold mt-1">
                                                        •
                                                    </span>

                                                    <p className="text-gray-700 text-sm leading-6">
                                                        {ins.instruction}
                                                    </p>
                                                </div>
                                            ))}
                                        </div>

                                    </div>

                                </div>
                            )}


                            {/* Reviews */}
                            {activeTab === "Reviews" && (
                                <div className="bg-white p-6 rounded-xl shadow-md border mt-8">

                                    <h2 className="text-xl font-bold text-slate-900 mb-6">
                                        What Travellers Say
                                    </h2>

                                    <div className="space-y-4">

                                        {reviews.map((review) => (
                                            <div
                                                key={review.id}
                                                className="rounded-2xl border border-slate-200 bg-slate-50 p-5"
                                            >
                                                <div className="flex items-center justify-between mb-3">

                                                    <div>
                                                        <p className="font-semibold text-slate-900">
                                                            {review.reviewer_name || "Traveller"}
                                                        </p>

                                                        {review.is_verified === 1 && (
                                                            <span className="text-xs text-green-600">
                                                                ✓ Verified Traveller
                                                            </span>
                                                        )}
                                                    </div>

                                                    <div className="flex items-center gap-1">
                                                        <span>⭐</span>
                                                        <span className="font-bold">
                                                            {Number(review.rating).toFixed(1)}
                                                        </span>
                                                    </div>

                                                </div>

                                                <p className="text-gray-700 leading-6">
                                                    “{review.review_text}”
                                                </p>
                                            </div>
                                        ))}

                                    </div>

                                </div>
                            )}
                            {/* FAQ */}





                            {activeTab === "FAQ's" && (
                                <div className="rounded-3xl border border-orange-100 bg-gradient-to-br from-orange-50 via-white to-red-50 p-6 shadow-sm hover:shadow-lg transition-all duration-300">

                                    <div className="space-y-3">
                                        {faqs.map((faq) => (
                                            <div
                                                key={faq.id}
                                                className="border border-slate-200 rounded-xl p-4"
                                            >
                                                <h3 className="font-semibold text-slate-900">
                                                    {faq.question}
                                                </h3>

                                                <p className="text-gray-600 mt-2 leading-6">
                                                    {faq.answer}
                                                </p>
                                            </div>
                                        ))}
                                    </div>

                                </div>
                            )}





                            {/* 

                            {activeTab === "Policies" && (
                                <div className="bg-white p-6 rounded-xl shadow-md border">
                                    <h2 className="font-bold mb-4">Policies</h2>
                                    {event?.poli?.map?.((poli, i) => (
                                        <details key={i} className="border-b py-3 group cursor-pointer">
                                            <summary className="font-semibold flex justify-between items-center">
                                                {poli.question}
                                                <span className="text-gray-500 transition-transform group-open:rotate-180">
                                                    ▼
                                                </span>
                                            </summary>
                                            <p className="mt-2  text-gray-600">{poli.answer}</p>
                                        </details>
                                    )) ||
                                        <p>No Policies available</p>
                                    }
                                </div>
                            )} */}




                            {activeTab === "Policies" && (
                                <div className="bg-white p-6 rounded-xl shadow-md border">
                                    <div className="space-y-4">
                                        {policies.map((policy) => (
                                            <div
                                                key={policy.id}
                                                className="rounded-2xl border border-slate-200 p-3"
                                            >
                                                <h3 className="font-bold text-slate-900 mb-2">
                                                    {policy.policy_title}
                                                </h3>

                                                <p className="text-sm text-slate-600 leading-6">
                                                    {policy.policy_description}
                                                </p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                        </div>

































                    </div>
                    {/* ================= RIGHT SIDEBAR ================= */}
                    <div className="lg:col-span-3 lg:sticky lg:top-24 bg-white h-fit rounded-xl shadow-xl border p-6 space-y-4" ref={selectedPackageRef} id="selected-package-card">



                        <div className="relative border rounded-2xl p-4 bg-white overflow-hidden">
                            {/* Ribbon */}
                            <div className="absolute -left-10 top-3 -rotate-45 bg-blue-500 text-white text-[10px] font-bold py-1 w-32 text-center shadow">
                                Starts from
                            </div>
                            <div className="flex items-center justify-between pl-6">
                                {/* Price */}
                                <div>
                                    <div className="text-3xl font-bold leading-none">
                                        ₹{selectedPackage?.offer_price}
                                    </div>
                                    <div className="text-sm text-gray-500 mt-1">
                                        per person
                                    </div>
                                </div>
                                {/* Button */}
                                <button
                                    onClick={() => {
                                        document
                                            .getElementById("price-section")
                                            ?.scrollIntoView({
                                                behavior: "smooth",
                                                block: "start",
                                            });
                                    }}
                                    className="text-blue-600 font-semibold text-sm hover:underline whitespace-nowrap"
                                >
                                    View Packages
                                </button>

                            </div>
                        </div>
                        <div className="fixed bottom-0 left-0 right-0 bg-white border-t shadow-xl p-4 z-50 lg:hidden">
                            <div className="flex items-center justify-between gap-3">

                                <div className="min-w-0">
                                    <p className="text-xs text-gray-500">
                                        Starting From
                                    </p>

                                    <h2 className="truncate font-bold">
                                        ₹ {Number(packageTotal).toLocaleString()}
                                    </h2>
                                </div>

                                <button
                                    onClick={() => {
                                        document.getElementById("selected-package-card")?.scrollIntoView({
                                            behavior: "smooth",
                                            block: "start",
                                        });
                                    }}
                                    className="shrink-0 rounded-xl bg-black px-5 py-3 font-semibold text-white sm:px-8"
                                >
                                    Book Now
                                </button>

                            </div>
                        </div>





                        {/* DATE SELECT */}
                        <div className="relative">
                            <div
                                onClick={() => {
                                    setShowCalendar(!showCalendar);
                                    setShowGuests(true);
                                }}
                                className="border rounded-xl p-3 bg-gray-50 flex justify-between items-center cursor-pointer hover:bg-gray-100 transition">
                                <div className="flex items-center gap-3">

                                    <span className="text-lg">📅</span>

                                    <div>
                                        <div className="text-xs text-gray-500">
                                            Select date
                                        </div>

                                        <div className="font-medium text-sm">
                                            {selectedDate
                                                ? selectedDate.toLocaleDateString("en-US", {
                                                    month: "short",
                                                    day: "2-digit",
                                                    year: "numeric",
                                                })
                                                : "Choose a date"}
                                        </div>
                                    </div>
                                </div>

                                <span className="text-sm">
                                    {showCalendar ? "▲" : "▼"}
                                </span>
                            </div>


                            {/* TIME SELECT */}
                            <div className="relative">
                                <div
                                    onClick={() => setShowTimings(!showTimings)}
                                    className="border rounded-xl p-3 bg-gray-50 mt-3 flex justify-between items-center cursor-pointer hover:bg-gray-100 transition ">
                                    <div className="flex items-center gap-3">
                                        <span className="text-lg">🕒</span>

                                        <div>
                                            <div className="text-xs text-gray-500">
                                                Select Time
                                            </div>

                                            <div className="font-medium text-sm">
                                                {selectedTiming
                                                    ? selectedTiming.timings
                                                    : "Choose a time slot"}
                                            </div>
                                        </div>
                                    </div>

                                    <span className={`transition-transform ${showTimings ? "rotate-180" : ""}`}>
                                        ▼
                                    </span>

                                </div>

                                {/* DROPDOWN */}
                                {showTimings && (
                                    <div className="mt-2 rounded-xl border bg-white shadow-lg overflow-hidden">
                                        {durationTimings?.map((item) => (
                                            <button
                                                key={item.id}
                                                type="button"
                                                onClick={() => {
                                                    setSelectedTiming(item);
                                                    setTimeError("");
                                                    setShowTimings(false);
                                                }}
                                                className={`w-full px-4 py-3 text-left transition border-b last:border-b-0
                                         ${selectedTiming?.id === item.id
                                                        ? "bg-blue-600 text-white"
                                                        : "hover:bg-blue-50"
                                                    }`}
                                            >
                                                {item.timings}
                                            </button>
                                        ))}
                                    </div>
                                )}

                                {timeError && (
                                    <p className="mt-2 text-sm text-red-600">
                                        {timeError}
                                    </p>
                                )}
                            </div>


                            {/* CALENDAR */}
                            {showCalendar && (
                                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" onClick={() => setShowCalendar(false)}>
                                    <div className="relative w-full max-w-md rounded-2xl bg-white p-5 shadow-2xl" onClick={(e) => e.stopPropagation()}>

                                        {/* Close Button */}
                                        <button
                                            onClick={() => setShowCalendar(false)}
                                            className="absolute right-4 top-4 text-gray-500 hover:text-black"
                                        >
                                            ✕
                                        </button>

                                        {/* HEADER */}
                                        <div className="flex items-center justify-between mb-5 mt-2">
                                            <button
                                                onClick={() => {
                                                    if (baseMonth === 0) {
                                                        setBaseMonth(11);
                                                        setBaseYear(baseYear - 1);
                                                    } else {
                                                        setBaseMonth(baseMonth - 1);
                                                    }
                                                }}
                                                className="w-8 h-8 rounded-full hover:bg-gray-100 flex items-center justify-center"
                                            >
                                                ←
                                            </button>

                                            <div className="text-center">
                                                <div className="text-xs text-gray-400">{baseYear}</div>
                                                <div className="font-bold uppercase">
                                                    {new Date(baseYear, baseMonth).toLocaleString("en-US", {
                                                        month: "short",
                                                    })}
                                                </div>
                                            </div>

                                            <button
                                                onClick={() => {
                                                    if (baseMonth === 11) {
                                                        setBaseMonth(0);
                                                        setBaseYear(baseYear + 1);
                                                    } else {
                                                        setBaseMonth(baseMonth + 1);
                                                    }
                                                }}
                                                className="w-8 h-8 rounded-full hover:bg-gray-100 flex items-center justify-center"
                                            >
                                                →
                                            </button>
                                        </div>

                                        {/* WEEK DAYS */}
                                        <div className="grid grid-cols-7 text-[11px] text-gray-400 mb-2">
                                            {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((d) => (
                                                <div key={d} className="text-center py-2">
                                                    {d}
                                                </div>
                                            ))}
                                        </div>

                                        {/* DAYS */}
                                        <div className="grid grid-cols-7 gap-1">
                                            {generateCalendar(baseYear, baseMonth).map((d, i) => {
                                                if (!d) return <div key={i} />;

                                                const thisDate = new Date(baseYear, baseMonth, d);

                                                const isPast =
                                                    thisDate <
                                                    new Date(
                                                        today.getFullYear(),
                                                        today.getMonth(),
                                                        today.getDate()
                                                    );

                                                const isSelected =
                                                    selectedDate &&
                                                    thisDate.toDateString() === selectedDate.toDateString();

                                                return (
                                                    <button
                                                        key={i}
                                                        disabled={isPast}
                                                        onClick={() => {
                                                            setSelectedDate(thisDate);
                                                            setShowCalendar(false);
                                                        }}
                                                        className={`min-h-[44px] rounded-lg text-xs transition flex flex-col items-center justify-center
                                                       ${isSelected
                                                                ? "bg-blue-600 text-white"
                                                                : isPast
                                                                    ? "text-gray-300 cursor-not-allowed"
                                                                    : "bg-blue-100 hover:bg-blue-200 text-blue-900"
                                                            }`}
                                                    >
                                                        <span className="font-semibold">{d}</span>

                                                        {!isPast && (
                                                            <span className="text-[9px] leading-none">
                                                                ₹{selectedPackage?.offer_price || 2000}
                                                            </span>
                                                        )}
                                                    </button>
                                                );
                                            })}
                                        </div>

                                        {/* FOOTER */}
                                        <div className="flex items-center gap-5 mt-5 text-xs">
                                            <div className="flex items-center gap-2">
                                                <div className="w-3 h-3 rounded-full bg-green-300"></div>
                                                <span className="text-gray-500">Available</span>
                                            </div>

                                            <div className="flex items-center gap-2">
                                                <div className="w-3 h-3 rounded-full bg-yellow-300"></div>
                                                <span className="text-gray-500">Filling Fast</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        {showGuests && (

                            <div
                                className={`border rounded-lg p-3 flex justify-between items-center transition
                              ${selectedDate
                                        ? "bg-gray-50 cursor-pointer hover:bg-gray-100"
                                        : "bg-gray-100 cursor-not-allowed opacity-10"
                                    }`}
                                onClick={() => {
                                    if (selectedDate) {
                                        setOpenParticipants(true);
                                    }
                                }}
                            >
                                <div className="flex items-center gap-2">
                                    <Users size={18} />
                                    <span className="font-medium">Guests</span>
                                </div>

                                <span>▼</span>
                            </div>
                        )}






                        {/* PARTICIPANTS BODY */}
                        {openParticipants && (
                            <div
                                className="fixed inset-0 z-[9999] bg-black/50 flex items-center justify-center p-2 sm:p-4"
                                onClick={() => setOpenParticipants(false)}
                            >
                                <div
                                    onClick={(e) => e.stopPropagation()}
                                    className="
                                        relative
                                        w-full
                                        max-w-[95vw]
                                        sm:max-w-[90vw]
                                        md:max-w-[750px]
                                        lg:max-w-[900px]
                                        xl:max-w-[1000px]
                                        max-h-[75vh]
                                        overflow-y-auto
                                        rounded-2xl
                                        bg-white
                                        p-4
                                        sm:p-5
                                        md:p-6
                                        shadow-2xl
                                    "
                                >
                                    {/* Close */}
                                    <button
                                        onClick={() => setOpenParticipants(false)}
                                        className="absolute top-4 right-4 text-gray-500 hover:text-black"
                                    >
                                        ✕
                                    </button>

                                    {/* Title */}
                                    <h2 className="mb-6 text-lg sm:font-bold">
                                        Select Guests
                                    </h2>

                                    {/* Adult */}
                                    <div className="flex items-center justify-between border-b py-4">
                                        <div>
                                            <h3 className="font-semibold text-sm sm:text-base">
                                                Adult
                                            </h3>
                                            <p className="text-xs text-gray-500">
                                                (Age 12-99)
                                            </p>
                                        </div>

                                        <div className="flex items-center gap-3">
                                            <button
                                                className="w-8 h-8 rounded-full border"
                                                onClick={() => updateCount("adult", "dec")}
                                            >
                                                −
                                            </button>

                                            <span className="w-6 text-center">
                                                {participants.adult}
                                            </span>

                                            <button
                                                className="w-8 h-8 rounded-full border"
                                                onClick={() => {
                                                    updateCount("adult", "inc");
                                                    setOpenCarAddon(true);
                                                }}
                                            >
                                                +
                                            </button>
                                        </div>
                                    </div>

                                    {/* Child */}
                                    <div className="flex items-center justify-between border-b py-4">
                                        <div>
                                            <h3 className="font-semibold text-sm sm:text-base">
                                                Child
                                            </h3>
                                            <p className="text-xs text-gray-500">
                                                (Age 2-11)
                                            </p>
                                        </div>

                                        <div className="flex items-center gap-3">
                                            <button
                                                className="w-8 h-8 rounded-full border"
                                                onClick={() => updateCount("child", "dec")}
                                            >
                                                −
                                            </button>

                                            <span className="w-6 text-center">
                                                {participants.child}
                                            </span>

                                            <button
                                                className="w-8 h-8 rounded-full border"
                                                onClick={() => updateCount("child", "inc")}
                                            >
                                                +
                                            </button>
                                        </div>
                                    </div>

                                    {/* Infant */}
                                    <div className="flex items-center justify-between border-b py-4">
                                        <div>
                                            <h3 className="font-semibold text-sm sm:text-base">
                                                Infant
                                            </h3>
                                            <p className="text-xs text-gray-500">
                                                (Age 1 and younger)
                                            </p>
                                        </div>

                                        <div className="flex items-center gap-3">
                                            <button
                                                className="w-8 h-8 rounded-full border"
                                                onClick={() => updateCount("infant", "dec")}
                                            >
                                                −
                                            </button>

                                            <span className="w-6 text-center">
                                                {participants.infant}
                                            </span>

                                            <button
                                                className="w-8 h-8 rounded-full border"
                                                onClick={() => updateCount("infant", "inc")}
                                            >
                                                +
                                            </button>
                                        </div>
                                    </div>

                                    <p className="mt-3 text-xs text-gray-500">
                                        Ages 1 and younger do not require a ticket.
                                    </p>

                                    {/* Vehicle Section */}
                                    <div className="mt-6 border-t pt-6">

                                        <div className="mb- rounded-xl p-2">
                                            <h2 className="text-base sm:text-lg font-bold text-gray-600">
                                                {recommendedVehicle?.type}
                                            </h2>

                                            <p className="mt-1 text-xs text-gray-500">
                                                Total Guests : {totalGuests}
                                            </p>
                                        </div>

                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                            {availableVehicles.map((item) => {
                                                const isLowestPrice = item.id === cheapestVehicle?.id;

                                                const isSelected = selectedAddons.some(
                                                    (addon) => addon.id === item.id
                                                );

                                                return (
                                                    <div
                                                        key={item.id}
                                                        onClick={() => handleSelectAddon(item)}
                                                        className={`
                                                    relative cursor-pointer rounded-2xl p-4 transition-all duration-300 border
                                                    ${isSelected
                                                                ? "bg-[#e9f1fb] border-blue-400"
                                                                : "bg-white hover:border-blue-300"}
                                                    `}
                                                    >
                                                        {isSelected && (
                                                            <div className="absolute top-3 right-3">
                                                                <input
                                                                    type="checkbox"
                                                                    checked
                                                                    readOnly
                                                                    className="h-5 w-5"
                                                                />
                                                            </div>
                                                        )}

                                                        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4">

                                                            <img
                                                                src={item.image}
                                                                alt={item.title}
                                                                className="h-20 w-full max-w-[150px] object-contain sm:h-[90px] sm:w-[150px] sm:flex-shrink-0"
                                                                onError={(e) => {
                                                                    e.target.src =
                                                                        "https://cdn-icons-png.flaticon.com/512/744/744465.png";
                                                                }}
                                                            />

                                                            <div className="flex-1">
                                                                <h3 className="font-semibold text-sm">
                                                                    {item.title}
                                                                </h3>

                                                                <p className="text-gray-600 text-sm mt-1">
                                                                    {item.type}
                                                                </p>

                                                                <h2 className="mt-2 font-bold text-lg text-[#1e3a8a]">
                                                                    ₹ {Number(item.price).toLocaleString("en-IN")}
                                                                </h2>
                                                            </div>

                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>




                                    {/* Done */}
                                    <div className="mt-6 flex justify-end">
                                        <button
                                            onClick={() => {
                                                setOpenParticipants(false);
                                                setShowPriceDetails(true);
                                            }}
                                            className="
                                        min-w-[180px]
                                        rounded-xl
                                        bg-blue-600
                                        px-6
                                        py-3
                                        text-sm
                                        sm:text-base
                                        font-semibold
                                        text-white
                                        hover:bg-green-700
                                        ">
                                            Done
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                        {showGuests && (

                            <div
                                onClick={() => {
                                    if (totalParticipants > 0) {
                                        setOpenParticipants(true);
                                    }
                                }}
                                className={`border rounded-lg p-3 flex justify-between items-center transition
                         ${totalParticipants > 0
                                        ? "bg-gray-50 cursor-pointer hover:bg-gray-100"
                                        : "bg-gray-100 cursor-not-allowed opacity-10"
                                    }`}>
                                <div className="flex items-center gap-2">
                                    <Car size={18} />
                                    <div>
                                        <p className="font-semibold text-sm">Add On (Optional)</p>
                                        <p
                                            className={`text-xs ${totalParticipants > 0 ? "text-gray-500" : "text-gray-300"
                                                }`}
                                        >
                                            Select extra vehicle services
                                        </p>
                                    </div>
                                </div>
                            </div>

                        )}

                        {showPriceDetails && (
                            <div className="border rounded-lg p-4 bg-gray-50 hover:bg-gray-100">
                                {/* Header */}
                                <div className="flex items-center gap-2 mb-4">
                                    <IndianRupee size={18} />
                                    <span className="font-semibold text-gray-800">
                                        Price Details
                                    </span>
                                </div>
                                {/* Total Guests */}
                                <div className="border-t pt-3">
                                    <div className="flex justify-between items-center font-semibold text-black">
                                        <span>Total Guests ({totalGuests})</span>
                                        <span>₹ {Number(packageTotal).toLocaleString()}</span>
                                    </div>
                                </div>
                                {/* Car Addons */}
                                <div className="border-t mt-4 pt-3">
                                    <div className="flex justify-between items-center mb-3">
                                        <span className="font-semibold text-black">
                                            Car Addons ({selectedAddons.length})
                                        </span>
                                    </div>

                                    {selectedAddons.length > 0 ? (
                                        <div className="space-y-3">
                                            {selectedAddons.map((addon) => (
                                                <div
                                                    key={addon.id}
                                                    className="grid grid-cols-[1fr_auto] gap-4 items-start"
                                                >
                                                    <span className="text-sm text-gray-700 break-words">
                                                        {addon.title}
                                                    </span>

                                                    <span className="text-sm font-semibold text-black whitespace-nowrap text-right">
                                                        ₹ {Number(addon.price).toLocaleString(undefined, {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2,
                                                        })}
                                                    </span>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <p className="text-sm text-gray-500">
                                            No addons selected
                                        </p>
                                    )}
                                </div>

                            </div>
                        )}


                        {/* CONTINUE BUTTON */}
                        <button
                            disabled={totalParticipants === 0 || !selectedDate}
                            onClick={handleContinue}
                            className={`w-full py-3 rounded-xl font-semibold transition 
                                   ${totalParticipants === 0 || !selectedDate
                                    ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                                    : "bg-blue-600 text-white hover:bg-blue-700"
                                }`}>
                            Continue
                        </button>
                        {totalParticipants === 0 && (
                            <div className="text-sm text-red-500 text-center">
                                At least 1 participant is required for this activity.
                            </div>
                        )}

                        <ItineraryDetails routeMap={routeMap} />
                    </div>
                </div>
            </div >



            <AiRecommendation
                dayPlan={dayPlan}
                frequentlyBookedTogether={frequentlyBookedTogether}
                exploreMoreDestinations={exploreMoreDestinations}
            />
        </div>
    );
};

function Field({ label, placeholder }) {
    return (
        <label className="block">
            <span className="mb-1 block font-semibold text-sub">{label}</span>
            <div className="flex items-center justify-between rounded-lg border border-line bg-white px-3.5 py-2.5 font-medium text-ink-soft transition hover:border-primary/50">
                <span className="text-sub">{placeholder}</span>
                <ChevronDown size={15} className="text-sub" />
            </div>
        </label>
    );
}


export default TripDetailPage;
